module.exports = __webpack_public_path__ + "img/completo_dx.6a466459.png";